import { render, staticRenderFns } from "./SubjectGroupSelect.vue?vue&type=template&id=7f3fcd3d&"
import script from "./SubjectGroupSelect.ts?vue&type=script&lang=ts&"
export * from "./SubjectGroupSelect.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports